export const EstadosGlosas = [
    "PENDIENTE",            /*   RECHAZADO_SAT     */
    "ANULADO",              /*   ANULADO_SAT       */
    "GESTIONAR",            /*   GESTIONADO_SAT    */
    "SOLUCIONADO",          /*   EXITO_ENVIO_SAT   */
    "NOTIFICACION_FUTURA",  /*   ENVIO_FUTURO      */
    "PROCESANDO",
    "INVALIDO",             /*   GESTION_INVALIDA  */
];

export const EstadoGlosa = {
    pendiente: EstadosGlosas[0],
    anulado: EstadosGlosas[1],
    gestionar: EstadosGlosas[2],
    solucionado: EstadosGlosas[3],
    notificacionfutura: EstadosGlosas[4],
    enproceso: EstadosGlosas[5],
    invalido: EstadosGlosas[6],
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/inconsistencias/modelo/EstadosGlosa.ts